<template>
    <div class="container">
        <div class="body-modal modal-game">
            <div>
                <div class="content">
                    <div>
                        <iframe :src="'./jeux/' + game.src" />
                    </div>
                    <div>
                        <span class="title">{{ game.title }}</span>
                        <div v-html="game.desc" class="desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Close from "../components/img/Close.vue";
import IconHaikara from "../components/img/IconHaikara.vue";

export default {
    name: "Game",
    data() {
        return {
            local: "fr",
            otherGames: [],
            game: null,
        };
    },
    components: {
        IconHaikara,
        Close,
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    beforeMount() {
        this.game = this.$store.state.app.modal.content;
        //this.runPropositions();
    },
    mounted() {
        this.local = this.$i18n.locale;
    },
    updated() {},
    methods: {
        showListReferences() {
            this.$store.dispatch("app/displayModal", {
                display: false,
            });
        },
        showNewGame(index) {
            this.reference = this.$store.state.app.games[this.local][index];
            this.runPropositions();
        },
        runPropositions() {
            this.otherGames = [];
            let games = this.$store.state.app.games[this.local];

            for (let i = 0; i < games.length; i++) {
                let game = games[i];
                if (this.game.title !== game.title) {
                    game.idx = i;
                    this.otherGames.push(game);
                }

                if (i === games.length - 1) {
                    this.shuffleArray(this.otherGames);
                    this.otherGames = this.otherGames.splice(0, 3);
                }
            }
        },
        shuffleArray(inputArray) {
            inputArray.sort(() => Math.random() - 0.5);
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-game {
    padding: 6rem 0;
    box-sizing: border-box;

    > div {
        max-width: 1400px;
        margin: auto;
    }

    .content {
        display: flex;
        flex-flow: row nowrap;

        > div {
            &:first-child {
                width: 70%;
                flex: 0 0 70%;
                padding-right: 2rem;
                box-sizing: border-box;

                iframe {
                    border-radius: 15px;
                    overflow: hidden;
                    width: 100%;
                    aspect-ratio: 1620/911;
                    border: 0;
                }
            }

            &:last-child {
                width: 30%;
                flex: 0 0 30%;
                display: flex;
                flex-flow: column;
            }
        }
    }

    .title {
        font-family: Oswald, sans-serif;
        color: #fff;
        font-size: 2.2rem;
        padding: 0;
        font-weight: 700;
    }

    .desc {
        color: #fff;
        padding: 0;
        font-size: 1.2rem;
        font-weight: 300;
    }
}
</style>
